"use client";

import Link from "next/link";
import { useParams } from "next/navigation";
import { Compass, Home } from "lucide-react";

import PageState from "@/features/home-v2/states/PageState";

// notFound() called anywhere under [lang] (assets/[tokenId], auctions/[slug],
// artists/[id], ...) looks for the nearest not-found.tsx up the tree. Without
// one here it fell through to the bare src/app/not-found.tsx — a generic,
// unlocalized page. This one renders nested under [lang]/layout.tsx so it
// gets the app chrome and can show localized copy.
export default function NotFound() {
  const params = useParams();
  const lang = params?.lang === "fa" ? "fa" : "en";
  const isFa = lang === "fa";

  return (
    <PageState
      glyph={isFa ? "۴۰۴" : "404"}
      eyebrow={isFa ? "قاب خالی" : "An empty frame"}
      title={isFa ? "این صفحه این‌جا نیست" : "This page isn't here"}
      body={isFa ? "نشانی اشتباه است یا این صفحه برداشته شده. از خانه یا بازار ادامه دهید." : "The address is wrong, or the page has been taken down. Carry on from home or the market."}
      actions={
        <>
          <Link href={`/${lang}`} className="v2-btn v2-focus"><Home aria-hidden />{isFa ? "بازگشت به خانه" : "Back home"}</Link>
          <Link href={`/${lang}/market`} className="v2-btn v2-btn--ghost v2-focus"><Compass aria-hidden />{isFa ? "گشتی در بازار" : "Browse the market"}</Link>
        </>
      }
    />
  );
}
